/**
 * クライアントの案件閲覧
 * @type {string}
 */
export const RFP_EVENT_TYPE_CLIENT_RFP_VIEW = 'EVENT_TYPE_CLIENT_RFP_VIEW';
/**
 * クライアントの提案閲覧
 * @type {string}
 */
export const RFP_EVENT_TYPE_CLIENT_OFFER_VIEW = 'EVENT_TYPE_CLIENT_OFFER_VIEW';
/**
 * クライアントの提案魅力度の未入力アラート
 * @type {string}
 */
export const RFP_EVENT_TYPE_CLIENT_OFFER_CHARM_POINT_ALERT = 'EVENT_TYPE_CLIENT_OFFER_CHARM_POINT_ALERT';
